<template>
  <el-dialog
    :visible.sync="innerVisible"
    width="85%"
    top="4vh"
    append-to-body
    :close-on-click-modal="false"
    @open="handleOpen"
    @close="handleClose"
  >
    <div slot="title" class="dialog-title-tabs">
      <el-tabs v-model="activeTab" class="title-tabs" @tab-click="handleTabChange">
        <el-tab-pane label="AI缓存" name="cache" />
        <el-tab-pane label="批注查看" name="annotation" />
      </el-tabs>
    </div>
    <div class="ai-cache-dialog">
      <div class="left-pane">
        <div class="left-toolbar">
          <el-button
            size="mini"
            type="primary"
            plain
            :loading="isCurrentListLoading"
            @click="refresh"
          >
            刷新
          </el-button>
        </div>

        <div class="left-table">
          <el-table
            :data="currentItems"
            size="mini"
            height="100%"
            highlight-current-row
            @row-click="handleRowClick"
          >
            <el-table-column prop="created_at" label="时间" width="170" />
            <el-table-column label="用户ID" width="110">
              <template slot-scope="scope">
                {{ formatUserId(scope.row.user_id) }}
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="left-footer">
          <el-button
            size="mini"
            type="primary"
            plain
            :loading="isCurrentListLoading"
            :disabled="!currentHasMore"
            @click="loadMore"
          >
            {{ currentHasMore ? '加载更多' : '没有更多了' }}
          </el-button>
        </div>
      </div>

      <div class="right-pane">
        <div v-if="activeTab === 'cache'" class="right-content">
          <div v-if="isCacheDetailLoading" class="placeholder">加载中...</div>
          <div v-else-if="!selectedCacheId" class="placeholder">请选择一条缓存</div>
          <EyeAI v-else :value="cacheDetailContent" />
        </div>

        <div v-else class="right-content split">
          <div class="split-top">
            <div v-if="isAnnotationDetailLoading" class="placeholder">加载中...</div>
            <div v-else-if="!selectedAnnotationHash" class="placeholder">请选择一条批注</div>
            <EyeAI v-else :value="annotationAiContent" />
          </div>
          <div class="split-bottom">
            <div v-if="!selectedAnnotationHash" class="annotation-placeholder">请先选择一条批注</div>
            <div v-else-if="isAnnotationDetailLoading" class="annotation-placeholder">加载批注中...</div>
            <div v-else-if="!annotationText" class="annotation-placeholder">暂无批注</div>
            <div v-else class="annotation-text">{{ annotationText }}</div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import EyeAI from './EyeAI.vue'

export default {
  name: 'AiCacheDialog',
  components: { EyeAI },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      innerVisible: false,
      activeTab: 'cache',

      limit: 20,
      cacheOffset: 0,
      cacheHasMore: true,
      cacheItems: [],
      isCacheListLoading: false,
      selectedCacheId: null,
      cacheDetailContent: '',
      isCacheDetailLoading: false,

      annotationOffset: 0,
      annotationHasMore: true,
      annotationItems: [],
      isAnnotationListLoading: false,
      selectedAnnotationHash: null,
      annotationAiContent: '',
      annotationText: '',
      isAnnotationDetailLoading: false
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.innerVisible = val
      }
    },
    innerVisible(val) {
      this.$emit('update:visible', val)
    }
  },
  methods: {
    formatUserId(value) {
      if (value === null || value === undefined || value === '') return '-'
      return String(value)
    },
    handleOpen() {
      this.activeTab = 'cache'
      this.refresh()
    },
    handleClose() {
      this.activeTab = 'cache'
      this.cacheItems = []
      this.cacheOffset = 0
      this.cacheHasMore = true
      this.selectedCacheId = null
      this.cacheDetailContent = ''
      this.isCacheListLoading = false
      this.isCacheDetailLoading = false

      this.annotationItems = []
      this.annotationOffset = 0
      this.annotationHasMore = true
      this.selectedAnnotationHash = null
      this.annotationAiContent = ''
      this.annotationText = ''
      this.isAnnotationListLoading = false
      this.isAnnotationDetailLoading = false
    },
    refresh() {
      if (this.activeTab === 'cache') {
        this.cacheOffset = 0
        this.cacheHasMore = true
        this.cacheItems = []
        this.selectedCacheId = null
        this.cacheDetailContent = ''
        this.fetchCacheList(true)
        return
      }

      this.annotationOffset = 0
      this.annotationHasMore = true
      this.annotationItems = []
      this.selectedAnnotationHash = null
      this.annotationAiContent = ''
      this.annotationText = ''
      this.fetchAnnotationList(true)
    },
    loadMore() {
      if (this.activeTab === 'cache') {
        if (!this.cacheHasMore || this.isCacheListLoading) return
        this.fetchCacheList(false)
        return
      }

      if (!this.annotationHasMore || this.isAnnotationListLoading) return
      this.fetchAnnotationList(false)
    },
    fetchCacheList(isFirstLoad) {
      this.isCacheListLoading = true
      const url = `/api/ai_cache/?limit=${this.limit}&offset=${this.cacheOffset}`
      this.$http
        .get(url)
        .then((response) => {
          const payload = response.data
          if (!payload || payload.status !== 'success' || !payload.data) {
            this.$message.error(payload?.message || '获取AI缓存失败')
            return
          }
          const newItems = payload.data.items || []
          this.cacheItems = this.cacheItems.concat(newItems)
          this.cacheOffset = (payload.data.next_offset !== undefined && payload.data.next_offset !== null)
            ? payload.data.next_offset
            : (this.cacheOffset + newItems.length)
          this.cacheHasMore = !!payload.data.has_more

          if (isFirstLoad && this.cacheItems.length > 0) {
            this.handleRowClick(this.cacheItems[0])
          }
        })
        .catch((error) => {
          this.$message.error(error?.response?.data?.message || '获取AI缓存失败')
        })
        .finally(() => {
          this.isCacheListLoading = false
        })
    },
    handleRowClick(row) {
      if (this.activeTab === 'cache') {
        if (!row || !row.id) return
        if (this.selectedCacheId === row.id) return
        this.selectedCacheId = row.id
        this.fetchCacheDetail(row.id)
        return
      }

      if (!row || !row.ai_analysis_hash) return
      if (this.selectedAnnotationHash === row.ai_analysis_hash) return
      this.selectedAnnotationHash = row.ai_analysis_hash
      this.fetchAnnotationDetail(row.ai_analysis_hash)
    },
    fetchCacheDetail(id) {
      this.isCacheDetailLoading = true
      const url = `/api/ai_cache/${id}/`
      this.$http
        .get(url)
        .then((response) => {
          const payload = response.data
          if (!payload || payload.status !== 'success' || !payload.data) {
            this.$message.error(payload?.message || '获取缓存详情失败')
            return
          }
          this.cacheDetailContent = payload.data.full_content || ''
        })
        .catch((error) => {
          this.$message.error(error?.response?.data?.message || '获取缓存详情失败')
        })
        .finally(() => {
          this.isCacheDetailLoading = false
        })
    },
    handleTabChange() {
      if (this.activeTab === 'cache') {
        if (this.cacheItems.length === 0) this.refresh()
        return
      }
      if (this.annotationItems.length === 0) this.refresh()
    },
    fetchAnnotationList(isFirstLoad) {
      this.isAnnotationListLoading = true
      const url = `/api/annotation_records/?limit=${this.limit}&offset=${this.annotationOffset}`
      this.$http
        .get(url)
        .then((response) => {
          const payload = response.data
          if (!payload || payload.status !== 'success' || !payload.data) {
            this.$message.error(payload?.message || '获取批注列表失败')
            return
          }
          const newItems = payload.data.items || []
          this.annotationItems = this.annotationItems.concat(newItems)
          this.annotationOffset = (payload.data.next_offset !== undefined && payload.data.next_offset !== null)
            ? payload.data.next_offset
            : (this.annotationOffset + newItems.length)
          this.annotationHasMore = !!payload.data.has_more

          if (isFirstLoad && this.annotationItems.length > 0) {
            this.handleRowClick(this.annotationItems[0])
          }
        })
        .catch((error) => {
          this.$message.error(error?.response?.data?.message || '获取批注列表失败')
        })
        .finally(() => {
          this.isAnnotationListLoading = false
        })
    },
    fetchAnnotationDetail(hash) {
      this.isAnnotationDetailLoading = true
      const url = `/api/annotation_records/${hash}/`
      this.$http
        .get(url)
        .then((response) => {
          const payload = response.data
          if (!payload || payload.status !== 'success' || !payload.data) {
            this.$message.error(payload?.message || '获取批注失败')
            return
          }
          this.annotationAiContent = payload.data.ai_analysis_content || ''
          this.annotationText = payload.data.annotation_content || ''
        })
        .catch((error) => {
          this.$message.error(error?.response?.data?.message || '获取批注失败')
        })
        .finally(() => {
          this.isAnnotationDetailLoading = false
        })
    }
  },
  computed: {
    currentItems() {
      return this.activeTab === 'cache' ? this.cacheItems : this.annotationItems
    },
    currentHasMore() {
      return this.activeTab === 'cache' ? this.cacheHasMore : this.annotationHasMore
    },
    isCurrentListLoading() {
      return this.activeTab === 'cache' ? this.isCacheListLoading : this.isAnnotationListLoading
    }
  }
}
</script>

<style scoped>
/deep/ .el-dialog {
  max-height: 92vh;
  display: flex;
  flex-direction: column;
}

/deep/ .el-dialog__body {
  flex: 1 1 auto;
  overflow: hidden;
}

.dialog-title-tabs {
  width: 100%;
}

/deep/ .title-tabs > .el-tabs__header {
  margin: 0;
}

.ai-cache-dialog {
  display: flex;
  gap: 12px;
  height: calc(92vh - 120px);
  min-height: 420px;
}

.left-pane {
  width: 320px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: 0;
}

.left-toolbar {
  display: flex;
  justify-content: flex-start;
}

.left-table {
  flex: 1 1 auto;
  min-height: 0;
}

.left-footer {
  display: flex;
  justify-content: center;
}

.right-pane {
  flex: 1;
  min-width: 0;
  min-height: 0;
}

.right-content {
  height: 100%;
}

.right-content.split {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.split-top {
  flex: 1 1 auto;
  min-height: 0;
}

.split-bottom {
  flex: 0 0 180px;
  min-height: 0;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 8px;
  overflow: auto;
  box-sizing: border-box;
}

.annotation-placeholder {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
}

.annotation-text {
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 13px;
  line-height: 1.6;
  color: #303133;
}

.placeholder {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
}
</style>
